
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/segment",
      function () {
        return require("private-next-pages/segment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/segment"])
      });
    }
  